import { useLocation } from 'react-router'

import { SERVER_INTERACTION_PAGES_BLACK_LIST } from '@wwt/shared/config/serverInteractionPagesBlackList.ts'

import { useSession } from '@/shared/lib/hooks/useSession'
import { HeaderTemplate } from '@/shared/ui/HeaderTemplate'
import { HeaderMenu } from '@/widgets/header-menu'

// TODO: Remove this component when RootLayout will be ready
export const AppHeader = () => {
	const location = useLocation()

	const token = useSession.use.token()

	const allowShowHeaderMenu = !SERVER_INTERACTION_PAGES_BLACK_LIST.includes(
		location.pathname
	)

	return (
		<HeaderTemplate>
			{allowShowHeaderMenu && <HeaderMenu isAuthorized={token !== null} />}
		</HeaderTemplate>
	)
}
